(function UppercaseDirective($, Adzuki)
{
	'use strict';

	const directive = {
		mounted(el) {
			el.addEventListener('keyup', () => {
				el.value = el.value.toUpperCase();
			});
		},
	};

	Adzuki.VueDirectives.Uppercase = directive;
}(jQuery, window.Adzuki || {}));
